<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
           <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white"  text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs11>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Create Office</p>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-form id="add_office"
                                 @submit.prevent="validateBeforeSubmit('addOffice')" 
                                 data-vv-scope="addOffice" 
                                 ref="office_form"
                                 autocomplete="off"
                                  v-model="valid">
                                    <v-card-text>
                                        <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>

                                                    <v-text-field name="Name" label="Name" id="name" v-model="office_object.name" v-validate="'required'" :error-messages="errors.collect('addOffice.Name')">
                                                    <template v-slot:label >
                                                    Name <span style="color:red"> * </span>
                                                    </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-combobox :items="wings_list" name="Wing" v-model="office_object.wing_id" id="id" label="Wing" item-text="name" item-value="id" clearable v-validate="'required'" :error-messages="errors.collect('addOffice.Wing')">
                                                        <template v-slot:label >
                                                    Wing <span style="color:red"> * </span>
                                                    </template>
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field name="Unit No" label="Unit No" id="unit_no" v-model="office_object.unit_no" v-validate="'required'" :error-messages="errors.collect('addOffice.Unit No')">
                                                    <template v-slot:label >
                                                    Unit No <span style="color:red"> * </span>
                                                    </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-textarea name="Address" label="Address" id="address" v-model="office_object.address" rows="2" v-validate="'required'" :error-messages="errors.collect('addOffice.Address')">
                                                    <template v-slot:label >
                                                    Address <span style="color:red"> * </span>
                                                    </template>
                                                    </v-textarea>
                                                </v-flex>
                                            </v-layout>
                                             <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field 
                                                    name="Email" 
                                                    label="Email" 
                                                    id="email" 
                                                    v-model="office_object.email" 
                                                    v-validate="'required|email'" 
                                                    :error-messages="errors.collect('addOffice.Email')">
                                                    <template v-slot:label >
                                                    Email
                                                    <span style="color:red"> * </span>
                                                    </template>
                                                    </v-text-field>
                                                </v-flex>
                                               
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small :loading="loading" :disabled="loading" type="submit">Add</v-btn>
                                        <v-btn text small to="/offices">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    
</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    methods: {
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },

        uploadfile: function () {
            let formData = new FormData();
            formData.append('file', this.files);
            axios.post(`${process.env.VUE_APP_API_URL}/api/offices/uploadoffice`,
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.upload_office_dialog_box = false;
                   
                    if (response.data.status == 1) {
                        // this.$router.push({ name: 'offices'});
                        this.alert=true;
                        this.message = response.data.message;
                    }
                    if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = "Error Ocurred while importing data"
                    }
                })
                .catch(function () {

                });

        },

        addOffice: function () {
            this.loading = true;
            var wing_name = this.office_object.wing_id;
            if (this.office_object.wing_id.id == null) {
                this.office_object.wing_id = {};
                this.office_object.wing_id.id = null;
                this.office_object.wing_id.name = wing_name;
            }

            let new_office = Object.assign({}, this.office_object);
            axios.post(`${process.env.VUE_APP_API_URL}/api/offices`, new_office).then((response) => {
                if (response.data.status == 1) {
                    this.loading = false;
                    this.$router.push({name: 'showOfficeDetails',params: {
                        id: response.data.office.id,
                        success_message:'Office Created Successfully'}
                        });
                  
                    // this.alert=true;
                    // this.message = response.data.message;
                    
                }
                if (response.data.status == 0) {
                   this.alert_error=true;
                        this.error = response.data.message
                }

            }).catch((error) => {
                console.log(error);
            }).finally(() => {

            });
        },
        getWingsList: function () {
            axios.get(`${process.env.VUE_APP_API_URL}/api/wings/list`).then((response) => {
                if (response.data.status == 1) {
                    this.wings_list = response.data.wings_list;
                }
                if (response.data.status == 0) {
                    this.error = "Unable to get wing list";
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
    },
    data: () => {
        return {
            message: '',
            upload_office_dialog_box: false,
            files: null,
            error: '',
            office_object: {
                name: '',
                address: '',
                wing_id: '',
                email:'',
            },
            valid: false,
            wings_list: [],
            loader: null,
            loading: false,
           
            alert: false,
            alert_error:false
        }
    },
    mounted() {
        this.getWingsList();
    },
};
</script>

<style scoped>
.theme--light.v-card {
    background-color: #FFFFFF;
    color: rgba(0, 0, 0, 0.87);
    padding: 5%;
}
</style>
